import {CsvModel} from "../../util/CSVWriteUtil";
import {VisitWithAssignedDesksStats} from "../../components/visit-stat-block/OfficeVisitStats";
import {HoodItem} from "./SeatingPlanModel";
import {EmployeeRef, INeighbourhood} from "../../api/Model";
import {downloadNeighbourhoodVisitCsv} from "../neighbourhood-list/ExportNeighbourhoodVisitCsv";

export type ExportNeighbourhoodRow = {
    neighbourhood: HoodItem,
    stats: VisitWithAssignedDesksStats,
};

export function downloadNeighbourhoodsCsv(rows: ExportNeighbourhoodRow[]) {
    downloadNeighbourhoodVisitCsv(
        rows.map(row => ({
            neighbourhood: {
                name: row.neighbourhood.name,
                desks: row.neighbourhood.newDesks,
            },
            ...row.stats,
        })),
        'seating_plan_neighbourhoods',
    );
}

type ExportEmployeeRow = {
    employee: EmployeeRef,
    neighbourhood: INeighbourhood,
    visitsNumber: number,
    visitsPercent: number,
    assignedDeskRecommended: boolean,
}


const exportEmployeeModel = new CsvModel<ExportEmployeeRow>([
    {
        header: 'Employee',
        value: row => row.employee.fullName,
    },
    {
        header: 'Neighbourhood',
        value: row => row.neighbourhood.name,
    },
    {
        header: 'Visits',
        value: row => String(row.visitsNumber),
    },
    {
        header: 'Visits %',
        value: row => `${row.visitsPercent}%`,
    },
    {
        header: 'Assigned Desk Recommended',
        value: row => row.assignedDeskRecommended ? 'Yes' : 'No',
    },
]);

export function downloadNeighbourhoodEmployeesCsv(stats: ExportNeighbourhoodRow[]) {
    const rows: ExportEmployeeRow[] = [];

    stats.forEach(n => {
        const stats = n.stats.employeeStats;
        stats.employees.forEach(({employee, visits}) => {
            rows.push({
                employee,
                neighbourhood: n.neighbourhood,
                visitsNumber: visits.value,
                visitsPercent: visits.percent,
                assignedDeskRecommended: stats.assignedDeskRecommendationEmployees.has(employee.id),
            });
        })
    });

    const date = new Date();
    exportEmployeeModel.downloadCsv(`neighbourhood_employees_${date.toISOString()}.csv`, rows);
}
